/* eslint-disable max-len */
import { integrationsUrl } from 'SharedDir/backend/endpoints/administration-integration';
import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

const generateIntegrationConfigEndpoint = (url: string, id: number): IEndpointData => ({
  method: 'GET',
  url: `${SERVER_API}/integrations/${url}/${id.toString()}/configs/brief`,
});

export default {
  INTEGRATION_CONFIGS_ROUTE: (id: number) => generateIntegrationConfigEndpoint('routes', id),
  INTEGRATION_CONFIGS_PROFILE_TYPE: (id: number) =>
    generateIntegrationConfigEndpoint('profile-types', id),
  INTEGRATION_CONFIGS_PROJECT_FORM: (id: number) =>
    generateIntegrationConfigEndpoint('project-type-forms', id),
  INTEGRATION_CALL_ISSUE: (issueId: number, integrationConfigId: number): IEndpointData => ({
    method: 'POST',
    url: `${SERVER_API}/issues/${issueId.toString()}/integrations/${integrationConfigId.toString()}`,
  }),
  INTEGRATION_CALL_USER_PROFILE: (
    userProfileId: number,
    integrationConfigId: number
  ): IEndpointData => ({
    method: 'POST',
    url: `${SERVER_API}/user-profiles/${userProfileId.toString()}/integrations/${integrationConfigId.toString()}`,
  }),
  INTEGRATION_CALL_PROJECT: (projectId: number, integrationConfigId: number): IEndpointData => ({
    method: 'POST',
    url: `${SERVER_API}/projects/${projectId.toString()}/integrations/${integrationConfigId.toString()}`,
  }),
  INTEGRATION_PERSON: {
    RESULTS_ACTUAL: {
      method: 'GET',
      url: `${integrationsUrl}/persons/results/actual`,
    } as IEndpointData,
    RESULTS: {
      method: 'GET',
      url: `${integrationsUrl}/persons/results`,
    } as IEndpointData,
  },
};
